import { DOC_TYPE_OPTIONS } from '../services/api';

export interface DocTypeOption {
  key: string;
  label: string;
}

interface DocTypeTabsProps {
  value: string;
  onChange: (v: string) => void;
  /** 动态文档列表（项目申报「整套」按模板生成）；为空时回退到固定的申报书/可行性/考核指标 */
  documents?: DocTypeOption[];
}

/** 项目申报：文档切换。dynamic documents 优先，否则回退到固定的三文档类型 */
export default function DocTypeTabs({ value, onChange, documents }: DocTypeTabsProps) {
  // 传入了 documents（项目申报）则按传入列表展示；未传（老调用）回退到固定三文档
  const options: DocTypeOption[] = documents
    ? documents
    : DOC_TYPE_OPTIONS.map((o) => ({ key: o.value, label: o.label }));

  return (
    <div className="inline-flex flex-wrap border border-gray-300 rounded-lg overflow-hidden text-sm">
      {options.map((opt) => (
        <button
          key={opt.key}
          type="button"
          onClick={() => onChange(opt.key)}
          className={`px-3 py-1.5 transition-colors ${
            value === opt.key
              ? 'bg-blue-600 text-white'
              : 'bg-white text-gray-600 hover:bg-gray-50'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
